import { getPositiveItems } from "../../services/positiveItemService";
import { setData, setError, setLoading } from "../slices/positiveItemSlice";
import { AppThunk } from "../store";

export const fetchPositiveItems = (inspectionId: string): AppThunk => async (dispatch, getState) => {
    dispatch(setLoading(true));
    dispatch(setError(false));

    try {
        const response = await getPositiveItems(inspectionId);

        if (response) {
            dispatch(setData(response))
        } else {
            throw Error('no data');
        }
    } catch (e) {
        console.error(e);
        dispatch(setError(true));
    } finally {
        dispatch(setLoading(false));
    }
}